import React from 'react';
import { Link } from 'react-router-dom';
import { Truck, Clock, Smartphone, Store, ChevronRight, Check } from 'lucide-react';
import { Button } from '@/components/ui/button';

const LOGO_URL = "/logo-adegga.png";

const features = [
  {
    icon: Clock,
    title: 'Cardápio em 5 minutos',
    description: 'Templates prontos e cadastro em lote para começar rapidamente'
  },
  {
    icon: Smartphone,
    title: 'Mobile-First',
    description: 'Seus clientes fazem pedidos pelo celular com facilidade'
  },
  {
    icon: Truck,
    title: 'Gestão Completa',
    description: 'Pedidos, estoque, financeiro e clientes em um só lugar'
  },
  {
    icon: Store,
    title: 'Seu Link Exclusivo',
    description: 'Compartilhe seu cardápio digital no WhatsApp'
  }
];

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-[#1a1a2e]">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-[#0a0a0f]/90 backdrop-blur-md border-b border-white/5">
        <div className="max-w-6xl mx-auto px-4 py-4 flex items-center justify-between">
          <img src={LOGO_URL} alt="ADEGGA DELIVERY" className="h-8" />
          <div className="flex items-center gap-4">
            <Link to="/app/login">
              <Button variant="ghost" className="text-white">
                Entrar
              </Button>
            </Link>
            <Link to="/app/register">
              <Button className="btn-primary">
                Criar Loja
              </Button>
            </Link>
          </div>
        </div>
      </header>

      {/* Hero */}
      <section className="pt-32 pb-20 px-4">
        <div className="max-w-4xl mx-auto text-center">
          {/* Logo above text */}
          <img 
            src={LOGO_URL} 
            alt="ADEGGA DELIVERY" 
            className="h-20 sm:h-24 lg:h-28 mx-auto mb-8"
          />
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
            Seu <span className="text-[#ff6b00]">Delivery</span> sem complicação
          </h1>
          <p className="text-lg sm:text-xl text-white/60 mb-8 max-w-2xl mx-auto">
            Plataforma completa para adegas e distribuidoras de bebidas. 
            Crie seu cardápio digital em minutos e comece a vender.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/app/register">
              <Button className="btn-primary text-lg h-14 px-8 w-full sm:w-auto">
                Começar Grátis
                <ChevronRight className="w-5 h-5 ml-2" />
              </Button>
            </Link>
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="py-20 px-4 bg-[#0a0a0f]">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl font-bold text-white text-center mb-12">
            Tudo que você precisa para vender mais
          </h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {features.map((feature, i) => (
              <div key={i} className="card-adegga p-6 text-center">
                <div className="w-14 h-14 rounded-xl bg-[#ff6b00]/20 flex items-center justify-center mx-auto mb-4">
                  <feature.icon className="w-7 h-7 text-[#ff6b00]" />
                </div>
                <h3 className="text-lg font-bold text-white mb-2">{feature.title}</h3>
                <p className="text-white/60 text-sm">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Benefits */}
      <section className="py-20 px-4">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl font-bold text-white text-center mb-12">
            Por que escolher o ADEGGA?
          </h2>
          <div className="space-y-4">
            {[
              'Cadastro de produtos super rápido com modo planilha',
              'Templates prontos para adegas e distribuidoras',
              'Pedidos enviados diretamente para seu WhatsApp',
              'Controle de estoque automático',
              'Relatórios financeiros completos',
              'Sem taxa por pedido - pague apenas a mensalidade'
            ].map((benefit, i) => (
              <div key={i} className="flex items-center gap-4 p-4 bg-[#13131f] rounded-lg border border-white/5">
                <div className="w-8 h-8 rounded-full bg-[#ff6b00]/20 flex items-center justify-center flex-shrink-0">
                  <Check className="w-5 h-5 text-[#ff6b00]" />
                </div>
                <span className="text-white">{benefit}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 px-4 bg-[#ff6b00]">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-bold text-white mb-4">
            Pronto para começar?
          </h2>
          <p className="text-white/80 mb-8">
            Crie sua loja agora e comece a receber pedidos em minutos
          </p>
          <Link to="/app/register">
            <Button className="bg-white text-[#ff6b00] hover:bg-white/90 text-lg h-14 px-8 font-bold">
              Criar Minha Loja Grátis
            </Button>
          </Link>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-8 px-4 bg-[#0a0a0f] border-t border-white/5">
        <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
          <img src={LOGO_URL} alt="ADEGGA DELIVERY" className="h-6" />
          <p className="text-white/40 text-sm">
            © 2025 ADEGGA DELIVERY. Todos os direitos reservados.
          </p>
          <div className="flex gap-4">
            <Link to="/admin/login" className="text-white/40 text-sm hover:text-white">
              Admin
            </Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;
